import { useEffect, useState } from 'react';
import { PictureInPicture2 } from 'lucide-react';
import { floatingSupported, onFloatingChange, openFloating } from '../../lib/floatingTimer';

// Fallback button: some browsers only allow the floating window after a tap.
export const FloatTimerButton = () => {
  const [active, setActive] = useState(false);
  useEffect(() => onFloatingChange(setActive), []);
  if (!active || !floatingSupported()) return null;
  return (
    <button
      type="button" onClick={() => openFloating()}
      className="fixed bottom-4 left-4 z-50 inline-flex items-center gap-2 rounded-full border border-primary/50 bg-black/80 backdrop-blur-md px-4 py-2.5 text-xs font-semibold text-primary shadow-[0_0_24px_rgba(255,215,0,0.15)] active:scale-95 transition-transform"
      data-testid="float-timer-btn"
    >
      <PictureInPicture2 className="h-4 w-4" /> Float timer
    </button>
  );
};

export default FloatTimerButton;
